import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { CircleLogo } from "web/react/emo/circle-logo";
import { HStack } from "web/react/emo/h-stack";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { VerifiedBadge } from "web/react/emo/verified-badge";
import * as styles from "./seller-logo-card.css";

interface SellerLogoCardProps {
    imageURL: string;
    sellerName: string;
    size: "sm" | "md";
    isCheckout?: boolean;
    showExternalLinkIcon?: boolean;
    children?: React.ReactNode;
}

export function SellerLogoCard({
    imageURL,
    sellerName,
    size,
    isCheckout = false,
    showExternalLinkIcon = false,
    children,
}: SellerLogoCardProps): React.ReactElement {
    const title =
        size === "sm" ? (
            <Text textStyle="body" truncate>
                {sellerName}
            </Text>
        ) : (
            <Heading textStyle="hero-xs" truncate>
                {sellerName}
            </Heading>
        );

    return (
        <HStack spacing="sm" align="center">
            <div className={styles.logoContainer}>
                <CircleLogo size={size} imageURL={imageURL} name={sellerName} />
            </div>
            <div className={styles.content}>
                <HStack spacing="xxs" align="center">
                    {title}
                    {isCheckout && <VerifiedBadge size="sm" />}
                    {showExternalLinkIcon && <SVGIcon name="external-link" />}
                </HStack>
                {children}
            </div>
        </HStack>
    );
}
